'use client';

import { useAdaptiveModalCustom } from '@sbercloud/uikit-product-mobile-modal';
import { CSS_BREAKPOINTS } from '@sbercloud/uikit-product-utils';

import { useLayoutType } from '@/root/src/hooks';
import { useModalsCtx, useServerDataCtx } from '@/root/src/hooks/ctx';

import { InitialSearch } from './InitialSearch';
import s from './styles.module.scss';

export function SearchModal() {
  const { closeModal, modalsState } = useModalsCtx();

  const { headers } = useServerDataCtx();
  const layoutType = useLayoutType(CSS_BREAKPOINTS, headers.xLayoutType);

  const AdaptiveModalCustom = useAdaptiveModalCustom({ layoutType });

  return (
    <AdaptiveModalCustom
      // @ts-ignore TODO remove when be able
      size='m'
      open={modalsState.initialSearch}
      onClose={() => closeModal('initialSearch')}
      className={s.modal_custom}
    >
      <InitialSearch />
    </AdaptiveModalCustom>
  );
}
